import React from 'react';

class Loader extends React.Component {
    render () {
        const loaderType = this.props.type || 'NORMAL';
        
        return (
            <div {...this.props} className={['component-loader', this.props.className, 'type-' + loaderType].join(' ')}>
                <div className="loader-blob loader-blob-1"></div>
                <div className="loader-blob loader-blob-2"></div>
                <div className="loader-blob loader-blob-3"></div>
            </div>
        )
    }
}

export default Loader;



// WEBPACK FOOTER //
// ./web-app/components/loader.jsx